module.exports = new __parcel__URL__("mouse.41afbf16.png").toString();